import type { IconType } from './../../models/icon';
import { AddIcon } from './AddIcon';
import { CalendarIcon } from './CalendarIcon';
import { CloseIcon } from './CloseIcon';
import { CreditCardIcon } from './CreditCardIcon';
import { DeleteIcon } from './DeleteIcon';
import { DiamondIcon } from './DiamondIcon';
import { DownloadIcon } from './DownloadIcon';
import { EditIcon } from './EditIcon';
import { MailIcon } from './MailIcon';
import { HeadsetIcon } from './HeadsetIcon';
import { HideIcon } from './HideIcon';
import { HouseIcon } from './HouseIcon';
import { MultipleDocumentIcon } from './MultipleDocumentIcon';
import { SingleDocumentIcon } from './SingleDocumentIcon';
import { PriceTagIcon } from './PriceTagIcon';
import { InformationIcon } from './InformationIcon';
import { MenuIcon } from './MenuIcon';
import { SearchIcon } from './SearchIcon';
import { QuestionIcon } from './QuestionIcon';
import { UserIcon } from './UserIcon';
import { MaximizeIcon } from './MaximizeIcon';
import { MinimizeIcon } from './MinimizeIcon';
import { ProfileIcon } from './ProfileIcon';
import { SettingsIcon } from './SettingsIcon';
import { RemoveIcon } from './RemoveIcon';
import { ShowIcon } from './ShowIcon';
import { TimerIcon } from './TimerIcon';
import { BankIcon } from './BankIcon';
import { BillIcon } from './BillIcon';
import { BarsIcon } from './BarsIcon';
import { CashIcon } from './CashIcon';
import { GraphIcon } from './GraphIcon';
import { DealIcon } from './DealIcon';
import { GiftIcon } from './GiftIcon';
import { ArrowRightIcon } from './ArrowRightIcon';
import { GiftGivingIcon } from './GiftGivingIcon';
import { LoanIcon } from './LoanIcon';
import { MoneyBagIcon } from './MoneyBagIcon';
import { ParcelIcon } from './ParcelIcon';
import { PercentageIcon } from './PercentageIcon';
import { PieChartIcon } from './PieChartIcon';
import { RefinanceIcon } from './RefinanceIcon';
import { SafeIcon } from './SafeIcon';
import { ShoppingCartIcon } from './ShoppingCartIcon';
import { StorefrontIcon } from './StorefrontIcon';
import { WalletIcon } from './WalletIcon';
import { ChairIcon } from './ChairIcon';
import { CoffeeIcon } from './CoffeeIcon';
import { CloudIcon } from './CloudIcon';
import { EarthIcon } from './EarthIcon';
import { HeartIcon } from './HeartIcon';
import { LightbulbIcon } from './LightbulbIcon';
import { LightningIcon } from './LightningIcon';
import { LikeIcon } from './LikeIcon';
import { PaintIcon } from './PaintIcon';
import { PeaceIcon } from './PeaceIcon';
import { PartyIcon } from './PartyIcon';
import { PhoneIcon } from './PhoneIcon';
import { PictureIcon } from './PictureIcon';
import { PlaneIcon } from './PlaneIcon';
import { TheatreIcon } from './TheatreIcon';
import { UmbrellaIcon } from './UmbrellaIcon';
import { ArrowUpIcon } from './ArrowUpIcon';
import { ArrowDownIcon } from './ArrowDownIcon';
import { ArrowLeftIcon } from './ArrowLeftIcon';
import { ChevronFilledUpIcon } from './ChevronFilledUpIcon';
import { ChevronFilledDownIcon } from './ChevronFilledDownIcon';
import { ChevronFilledLeftIcon } from './ChevronFilledLeftIcon';
import { ChevronFilledRightIcon } from './ChevronFilledRightIcon';
import { UploadIcon } from './UploadIcon';
import { ChevronUpIcon } from './ChevronUpIcon';
import { ChevronDownIcon } from './ChevronDownIcon';
import { ChevronRightIcon } from './ChevronRightIcon';
import { ChevronLeftIcon } from './ChevronLeftIcon';
import { FaceIdIcon } from './FaceIdIcon';
import { LogoutIcon } from './LogoutIcon';
import { LoginIcon } from './LoginIcon';
import { LinkIcon } from './LinkIcon';
import { HamburgerIcon } from './Hamburger';
import { FacebookIcon } from './FacebookIcon';
import { LinkedInIcon } from './LinkedinIcon';
import { InstagramIcon } from './InstagramIcon';
import { TwitterIcon } from './TwitterIcon';
import { SwedenFlagIcon } from './SwedenFlagIcon';
import { NorwayFlagIcon } from './NorwayFlagIcon';
import { FinlandFlagIcon } from './FinlandFlagIcon';
import { XIcon } from './XIcon';
import { CopyIcon } from './CopyIcon';
import { CheckmarkIcon } from './CheckmarkIcon';
import { BankIdIcon } from './BankIdIcon';
import { SignIcon } from "./SignIcon";
import {PinCodeIcon} from "./PinCodeIcon";
import { InsuranceIcon } from './InsuranceIcon';
import { PrivacyCookiesIcon } from './PrivacyCookiesIcon'

export {
  HamburgerIcon,
  UserIcon,
  ArrowRightIcon,
  FacebookIcon,
  LinkedInIcon,
  InstagramIcon,
  TwitterIcon,
  SwedenFlagIcon,
  NorwayFlagIcon,
  FinlandFlagIcon,
  RemoveIcon,
  AddIcon,
  InformationIcon,
  CreditCardIcon,
  SearchIcon,
  DownloadIcon,
  QuestionIcon,
  CloseIcon, 
  SingleDocumentIcon,
  CalendarIcon,
  MultipleDocumentIcon,
  DeleteIcon,
  EditIcon,
  HouseIcon,
  HeadsetIcon,
  HideIcon,
  MenuIcon,
  MaximizeIcon,
  MinimizeIcon,
  ProfileIcon,
  SettingsIcon,
  ShowIcon,
  TimerIcon,
  BankIcon,
  DiamondIcon,
  BarsIcon,
  CashIcon,
  GraphIcon,
  DealIcon,
  GiftIcon,
  GiftGivingIcon,
  LoanIcon,
  PriceTagIcon,
  MoneyBagIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowUpIcon,
  ChairIcon,
  ChevronDownIcon,
  ChevronFilledDownIcon,
  ChevronFilledLeftIcon,
  ChevronFilledRightIcon,
  ChevronFilledUpIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  CloudIcon,
  CoffeeIcon,
  EarthIcon,
  FaceIdIcon,
  HeartIcon,
  LightningIcon,
  LightbulbIcon,
  LikeIcon,
  LinkIcon,
  LoginIcon,
  LogoutIcon,
  MailIcon,
  PaintIcon,
  ParcelIcon,
  PartyIcon,
  PeaceIcon,
  PercentageIcon,
  PhoneIcon,
  PictureIcon,
  PieChartIcon,
  PlaneIcon,
  PrivacyCookiesIcon,
  RefinanceIcon,
  SafeIcon,
  ShoppingCartIcon,
  StorefrontIcon,
  TheatreIcon,
  UmbrellaIcon,
  UploadIcon,
  WalletIcon,
  XIcon,
  CopyIcon,
  CheckmarkIcon, 
  SignIcon,
  PinCodeIcon, 
  InsuranceIcon,
};

export const icons = [
  { name: 'null',
    component: null
  },
  {
    name: 'hamburgerIcon',
    component: HamburgerIcon,
  },
  {
    name: 'copyIcon',
    component: CopyIcon,
  },
  {
    name: 'checkmarkIcon',
    component: CheckmarkIcon,
  },
  {
    name: 'arrowDownIcon',
    component: ArrowDownIcon,
  },
  {
    name: 'userIcon',
    component: UserIcon,
  },
  {
    name: 'facebookIcon',
    component: FacebookIcon,
  },
  {
    name: 'linkedinIcon',
    component: LinkedInIcon,
  },
  {
    name: 'instagramIcon',
    component: InstagramIcon,
  },
  {
    name: 'twitterIcon',
    component: TwitterIcon,
  },
  {
    name: 'swedenFlagIcon',
    component: SwedenFlagIcon,
  },
  {
    name: 'norwayFlagIcon',
    component: NorwayFlagIcon,
  },
  {
    name: 'finlandFlagIcon',
    component: FinlandFlagIcon,
  },
  {
    name: 'removeIcon',
    component: RemoveIcon,
  },
  {
    name: 'addIcon',
    component: AddIcon,
  },
  {
    name: 'informationIcon',
    component: InformationIcon,
  },
  {
    name: 'creditCardIcon',
    component: CreditCardIcon,
  },
  {
    name: 'searchIcon',
    component: SearchIcon,
  },
  {
    name: 'downloadIcon',
    component: DownloadIcon,
  },
  {
    name: 'questionIcon',
    component: QuestionIcon,
  },
  {
    name: 'closeIcon',
    component: CloseIcon,
  },
  {
    name: 'singleDocumentIcon',
    component: SingleDocumentIcon,
  },
  {
    name: 'calendarIcon',
    component: CalendarIcon,
  },
  {
    name: 'multipleDocumentIcon',
    component: MultipleDocumentIcon,
  },
  {
    name: 'deleteIcon',
    component: DeleteIcon,
  },
  {
    name: 'editIcon',
    component: EditIcon,
  },
  {
    name: 'houseIcon',
    component: HouseIcon,
  },
  {
    name: 'headsetIcon',
    component: HeadsetIcon,
  },
  {
    name: 'hideIcon',
    component: HideIcon,
  },
  {
    name: 'menuIcon',
    component: MenuIcon,
  },
  {
    name: 'mailIcon',
    component: MailIcon,
  },
  {
    name: 'maximizeIcon',
    component: MaximizeIcon,
  },
  {
    name: 'minimizeIcon',
    component: MinimizeIcon,
  },
  {
    name: 'profileIcon',
    component: ProfileIcon,
  },
  {
    name: 'settingsIcon',
    component: SettingsIcon,
  },
  {
    name: 'showIcon',
    component: ShowIcon,
  },
  {
    name: 'timerIcon',
    component: TimerIcon,
  },
  {
    name: 'bankIcon',
    component: BankIcon,
  },
  {
    name: 'bankIdIcon',
    component: BankIdIcon,
  },
  {
    name: 'billIcon',
    component: BillIcon,
  },
  {
    name: 'diamondIcon',
    component: DiamondIcon,
  },
  {
    name: 'arrowRightIcon',
    component: ArrowRightIcon,
  },
  {
    name: 'barsIcon',
    component: BarsIcon,
  },
  {
    name: 'cashIcon',
    component: CashIcon,
  },
  {
    name: 'graphIcon',
    component: GraphIcon,
  },
  {
    name: 'dealIcon',
    component: DealIcon,
  },
  {
    name: 'giftIcon',
    component: GiftIcon,
  },
  {
    name: 'giftGivingIcon',
    component: GiftGivingIcon,
  },
  {
    name: 'loanIcon',
    component: LoanIcon,
  },
  {
    name: 'priceTagIcon',
    component: PriceTagIcon,
  },
  {
    name: 'moneyBagIcon',
    component: MoneyBagIcon,
  },
  {
    name: 'parcelIcon',
    component: ParcelIcon,
  },
  {
    name: 'percentageIcon',
    component: PercentageIcon,
  },
  {
    name: 'pieChartIcon',
    component: PieChartIcon,
  },
  {
    name: 'refinanceIcon',
    component: RefinanceIcon,
  },
  {
    name: 'safeIcon',
    component: SafeIcon,
  },
  {
    name: 'shoppingCartIcon',
    component: ShoppingCartIcon,
  },
  {
    name: 'storefrontIcon',
    component: StorefrontIcon,
  },
  {
    name: 'walletIcon',
    component: WalletIcon,
  },
  {
    name: 'chairIcon',
    component: ChairIcon,
  },
  {
    name: 'coffeeIcon',
    component: CoffeeIcon,
  },
  {
    name: 'cloudIcon',
    component: CloudIcon,
  },
  {
    name: 'earthIcon',
    component: EarthIcon,
  },
  {
    name: 'heartIcon',
    component: HeartIcon,
  },
  {
    name: 'lightbulbIcon',
    component: LightbulbIcon,
  },
  {
    name: 'lightningIcon',
    component: LightningIcon,
  },
  {
    name: 'likeIcon',
    component: LikeIcon,
  },
  {
    name: 'paintIcon',
    component: PaintIcon,
  },
  {
    name: 'peaceIcon',
    component: PeaceIcon,
  },
  {
    name: 'partyIcon',
    component: PartyIcon,
  },
  {
    name: 'phoneIcon',
    component: PhoneIcon,
  },
  {
    name: 'pictureIcon',
    component: PictureIcon,
  },
  {
    name: 'planeIcon',
    component: PlaneIcon,
  },
  {
    name: 'theatreIcon',
    component: TheatreIcon,
  },
  {
    name: 'umbrellaIcon',
    component: UmbrellaIcon,
  },
  {
    name: 'arrowUpIcon',
    component: ArrowUpIcon,
  },
  {
    name: 'arrowDownIcon',
    component: ArrowDownIcon,
  },
  {
    name: 'arrowLeftIcon',
    component: ArrowLeftIcon,
  },
  {
    name: 'chevronFilledUpIcon',
    component: ChevronFilledUpIcon,
  },
  {
    name: 'chevronFilledDownIcon',
    component: ChevronFilledDownIcon,
  },
  {
    name: 'chevronFilledLeftIcon',
    component: ChevronFilledLeftIcon,
  },
  {
    name: 'chevronFilledRightIcon',
    component: ChevronFilledRightIcon,
  },
  {
    name: 'chevronUpIcon',
    component: ChevronUpIcon,
  },
  {
    name: 'chevronDownIcon',
    component: ChevronDownIcon,
  },
  {
    name: 'chevronLeftIcon',
    component: ChevronLeftIcon,
  },
  {
    name: 'chevronRightIcon',
    component: ChevronRightIcon,
  },
  {
    name: 'faceIdIcon',
    component: FaceIdIcon,
  },
  {
    name: 'logoutIcon',
    component: LogoutIcon,
  },
  {
    name: 'loginIcon',
    component: LoginIcon,
  },
  {
    name: 'linkIcon',
    component: LinkIcon,
  },
  {
    name: 'uploadIcon',
    component: UploadIcon,
  },
  {
    name: 'xIcon',
    component: XIcon,
  },
  {
      name: 'signIcon',
      component: SignIcon
  },
  {
      name: 'pinCodeIcon',
      component: PinCodeIcon,
  },
  {
      name: 'insuranceIcon',
      component: InsuranceIcon,
  },
  {
     name: 'privacyCookiesIcon',
     component: PrivacyCookiesIcon,
  }  
] as const

export type IconName = typeof icons[number]['name'];

export function getIconByName(name?: string): IconType['component'] | null {
  if(!name) return null
  const icon = icons.find((icon) => icon.name === name)?.component;
  if (!icon) return null;
  return icon;
}

interface IconComponentProps {
  iconName: IconName;
  className?: string;
  secondaryColor?: string;
  height?: number;
  width?: number;
}

export const IconComponent: React.FC<IconComponentProps> = ({ iconName, className, secondaryColor = 'var(--color-200)', height=24, width=24 }) => {

  // Get the Icon component from the iconName using the getIconByName function
  const Icon = getIconByName(iconName);
  
  if (!Icon) {
    console.warn(`Icon with name ${iconName} not found.`);
    return null;
  }
  
  // Render the Icon if it was found
  return <Icon className={className} secondaryColor={secondaryColor} height={height} width={width} />;
};